// framework/common/schemas/collections/apiKeys.js
import { z } from "zod";

const ApiKeySchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this key belongs to."),
    userId: z.string().describe("The user this key is associated with, for permission scoping."),
    
    prefix: z.string().describe("A non-secret prefix for easy identification (e.g., 'omnx_live_')."),
    keyHash: z.string().describe("A secure SHA-256 hash of the full API key for validation."),
    encryptedKey: z.string().describe("The encrypted full API key."),
    
    description: z.string().min(1, "A description is required.").describe("User-provided description for the key's purpose."),
    
    isEnabled: z.boolean().default(true).describe("A flag to enable or disable the key."),
    
    initialContext: z.record(z.any()).optional().nullable().describe("A default context object to be sent with webhook payloads from this key's owner."),

    expiresAt: z.coerce.date().optional().nullable().describe("Optional expiration date for the key."),
    lastUsedAt: z.coerce.date().optional().nullable().describe("Timestamp of the last time the key was used."),
    
    allowedIps: z.array(z.string()).optional().default([]).describe("Optional list of allowed IP addresses (CIDR notation supported)."),
    allowedMethods: z.array(z.string()).optional().default([]).describe("Optional list of allowed RPC methods (glob patterns supported)."),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ApiKeySchema;